import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CommunicationService } from '../shared/services/communication.service';

export interface HasUnsavedChanges {
    hasUnsavedChanges: () => boolean; // | Observable<boolean>;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<HasUnsavedChanges> {

    constructor(private communicationService: CommunicationService) {

    }

    // Note:  the following method is part of the mechanism that causes the browser to display a dialogue when the user tries to navigate and there are unsaved changes.
    // See https://stackoverflow.com/questions/35922071/warn-user-of-unsaved-changes-before-leaving-page
    // Also see https://community-dc.max.gov/x/MI4ynw for details
    public canDeactivate(component: HasUnsavedChanges): Observable<boolean> | boolean {
        if (component.hasUnsavedChanges()) {
            // A bit of a side effect, but this call ensures that any form open dialog that got initialized is prevented from opening.
            this.communicationService.cancelAnyOpenFormDialog();
            return confirm("It appears you have made changes. Click Cancel to stay on this page, or click OK to navigate away and lose any changes.");
        } else {
            return true;
        }
    }

}
